import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  linkText: {
    color: "#008DAE",
    "&:hover": {
      textDecoration: "underline",
      color: "#B0BEC5",
      cursor: "pointer",
    },
  },
  cardContainer: {
    width: 245,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-around",
    padding: 12,
    borderRadius: 4,
    fontSize: 14,
    fontWeight: 500,
  },
  feeSection: {
    "&:not(:last-child)": {
      marginBottom: 16,
    },
  },
  header: {
    marginBottom: 6,
  },
  feeOption: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: "4px 0px",
  },
  valueContainer: {
    border: "1px solid #B0BEC5",
    borderRadius: 4,
    height: 24,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 8,
    minWidth: 40,
    padding: "0px 4px",
  },
});

export const RFI_OPTIMIZED_FEE_OPTION = "RFI_OPTIMIZED_FEE_OPTION";
